import React from 'react';
import { FileText, Download } from 'lucide-react';

const DocumentRow = ({ doc }) => {
    return (
        <div className="flex items-center justify-between bg-white rounded-lg p-3 hover:shadow-md transition-shadow border border-gray-100 group">
            <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FEF2F2] rounded-md shrink-0">
                    <FileText size={24} className="text-red-500" strokeWidth={1.5} />
                </div>
                <div className="flex flex-col gap-0.5">
                    <p className="font-bold text-gray-900 text-[13px] md:text-sm uppercase tracking-wide">{doc.name}</p>
                    <p className="text-[11px] text-gray-500 font-medium uppercase tracking-wider">{doc.type} • {doc.size}</p>
                </div>
            </div>
            <button className="w-10 h-10 flex items-center justify-center hover:bg-gray-50 bg-white border border-gray-100 rounded-md transition-colors text-gray-400 hover:text-gray-700 shrink-0">
                <Download size={20} strokeWidth={1.5} />
            </button>
        </div>
    );
};

const PropertyDocuments = ({ documents }) => {
    if (!documents || documents.length === 0) return null;

    return (
        <div className="pt-10 pb-6">
            <h2 className="text-xl font-black text-gray-900 mb-6 flex items-center justify-start uppercase tracking-widest">
                Official documents
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {documents.map((doc, idx) => (
                    <DocumentRow key={idx} doc={doc} />
                ))}
            </div>
        </div>
    );
};

export default PropertyDocuments;
